import { jsx as _jsx } from "react/jsx-runtime";
import useTranslations from "@hooks/useTranslations";
const NoResultsCard = ({ height, maxWidth }) => {
    const { t } = useTranslations();
    return (_jsx("div", { className: "no-results-card-wrapper", children: _jsx("div", { className: "no-results-card-wrapper__body", style: { height: `${height}px`, maxWidth: `${maxWidth}px` }, children: _jsx("p", { className: "no-results-card-wrapper__body-text", children: t("BDO.LiveSite.Card.NoResultsFound") }) }) }));
};
export default NoResultsCard;
